export const hasDuration = (deliveryEstimation) =>
  !!(
    deliveryEstimation &&
    deliveryEstimation.duration &&
    (deliveryEstimation.duration.min || deliveryEstimation.duration.max)
  );

export function isDeliveryEstimationCollectedForAllProviders(quotes) {
  return (
    quotes.filter(
      (quote) =>
        quote.deliveryEstimation.providerGivesEstimate && !hasDuration(quote.deliveryEstimation),
    ).length === 0
  );
}
